import React from 'react';
import {
  Box,
  Checkbox,
  FormControlLabel,
  Tooltip,
  Typography,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { ACM } from '../../../constants/UserRoles';

export default function ShareOptions({
  typeOfUser,
  selectedStudent,
  shareWith,
  teachers,
  preRegisteredUsers,
  onShareWithChange,
}) {
  const isPreRegistered = (id) => {
    return preRegisteredUsers.some((student) => student.id === id);
  };

  // Show share options for teachers, doctors, and students
  // Students need to see that their teachers are automatically shared
  if (!ACM[typeOfUser]?.isDoctor && !ACM[typeOfUser]?.isTeacher && !ACM[typeOfUser]?.isStudent) {
    return null;
  }

  return (
    <Box>
      <Typography variant='body1' sx={{ mb: 1 }}>
        Share with:
      </Typography>
      <Box sx={{ width: '100%', mt: 1 }}>
        {/* Only show parent/guardian option for teachers/doctors, not for students */}
        {!ACM[typeOfUser]?.isStudent && !isPreRegistered(selectedStudent) && (
          <FormControlLabel
            control={
              <Checkbox
                checked={shareWith.includes('parent/guardian')}
                onChange={(e) => {
                  if (e.target.checked) {
                    onShareWithChange([...shareWith, 'parent/guardian']);
                  } else {
                    onShareWithChange(
                      shareWith.filter((id) => id !== 'parent/guardian')
                    );
                  }
                }}
              />
            }
            label={'Share with Parent/Guardian'}
          />
        )}

        {teachers?.length > 0 ? (
          teachers.map((teacher, index) => {
            const subRole = teacher?.info?.subRoleName;
            const showTooltip =
              !!subRole &&
              !(Array.isArray(subRole) && subRole.length === 0);

            return (
              <FormControlLabel
                key={teacher?.uid || index}
                control={
                  <Checkbox
                    checked={shareWith.includes(teacher?.uid)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        onShareWithChange([...shareWith, teacher?.uid]);
                      } else {
                        onShareWithChange(
                          shareWith.filter((id) => id !== teacher?.uid)
                        );
                      }
                    }}
                    value={teacher?.uid}
                    disabled={ACM[typeOfUser]?.isStudent} // Disable for students - teachers are auto-shared
                  />
                }
                label={
                  <span>
                    {ACM[typeOfUser]?.isStudent ? 'Shared with ' : 'Share with '}
                    {teacher?.info?.fullname}
                    {showTooltip && (
                      <Tooltip title={subRole} arrow placement='top'>
                        <InfoIcon
                          sx={{
                            fontSize: 'small',
                            ml: 0.5,
                            verticalAlign: 'middle',
                            color: 'action.active',
                            cursor: 'help',
                          }}
                        />
                      </Tooltip>
                    )}
                  </span>
                }
                sx={{ mr: 2 }}
              />
            );
          })
        ) : isPreRegistered(selectedStudent) ? (
          <Typography
            variant='body2'
            sx={{ mt: 2, color: 'text.secondary' }}
          >
            There is no one to share the progress report with.
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
} 